/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Grid, TextField } from "@material-ui/core";
import { Autocomplete, Box, createFilterOptions } from "@mui/material";

import { Button } from "../../../shared/widgets";
import { PageWrapper } from "../../../shared/layout";
import { fetchCityAgenciesAction } from "../../../redux/action-creators/adminConfigActionCreator";

const filterOptions = (type) => createFilterOptions({
  matchFrom: "any",
  stringify: (option) => (type === "city" ? option.cityName : option.name),
  limit: 500,
});

const renderOption = (params, option) => (
  <li {...params} key={option.cityId}>
    {option.cityName}
  </li>
);

const renderAgencyOption = (params, option) => (
  <li {...params} key={option.gpsId}>
    {option.name}
  </li>
);

function AdminConfig(props) {
  const { location: { pathname } } = props;
  const configType = pathname.split("/")[2];
  const dispatch = useDispatch();

  const [selectedCity, setSelectedCity] = useState({});
  const [selectedAgency, setSelectedAgency] = useState({});

  const history = useHistory();
  const cities = useSelector((state) => state.Cities.cities);
  const agencies = useSelector((state) => state.AdminConfig.cityAgencies);

  const handleOnClick = () => {
    history.push("/system-config/admin-city-config", { selectedCity, selectedAgency, configType });
  };

  useEffect(() => {
    if (configType === "agency-config" && Object.keys(selectedCity).length) {
      dispatch(
        fetchCityAgenciesAction({
          cityName: selectedCity?.cityName,
        }),
      );
    }
  }, [selectedCity]);

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header heading="City Configuration" hideS removeFilterOnly />
        <Box m={2} width={{ xs: "100%", sm: "70%", md: "40%" }}>
          <PageWrapper.Body style={{ backgroundColor: "white" }}>
            <Box padding={3}>
              <Grid container direction="column" spacing={7}>
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="flex-end"
                >
                  <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ fontWeight: "bold" }}>Select City</Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                      sx={{
                        "& .MuiInput-root": {
                          paddingBottom: "5px",
                        },
                        "& .MuiSvgIcon-root": {
                          fill: "black",
                        },
                      }}
                      data-testid="config-city"
                      value={selectedCity}
                      getOptionLabel={(option) => option.cityName || ""}
                      options={cities}
                      filterOptions={filterOptions("city")}
                      onChange={(event, newValue) => {
                        setSelectedCity(newValue || {});
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select City"
                          variant="standard"
                        />
                      )}
                      renderOption={renderOption}
                    />
                  </Grid>
                </Grid>
                {configType === "agency-config" && (
                  <Grid
                    container
                    item
                    justifyContent="center"
                    alignItems="flex-end"
                  >
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{ fontWeight: "bold" }}>Select Agency</Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Autocomplete
                        sx={{
                          "& .MuiInput-root": {
                            paddingBottom: "5px",
                          },
                          "& .MuiSvgIcon-root": {
                            fill: "black",
                          },
                        }}
                        data-testid="config-agency"
                        value={selectedAgency}
                        getOptionLabel={(option) => option.name || ""}
                        options={agencies}
                        filterOptions={filterOptions("agency")}
                        onChange={(event, newValue) => {
                          setSelectedAgency(newValue || {});
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Agency"
                            variant="standard"
                          />
                        )}
                        renderOption={renderAgencyOption}
                      />
                    </Grid>
                  </Grid>
                )}
                <Grid container item direction="row-reverse">
                  <Grid className="config-button" item ml={-10}>
                    <Button
                      buttonText="Edit Configuration"
                      disable={configType === "city-config" ? !Object.keys(selectedCity || {}).length : !(Object.keys(selectedCity || {}).length && Object.keys(selectedAgency || {}).length)}
                      onClick={handleOnClick}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </PageWrapper.Body>
        </Box>
      </PageWrapper>
    </div>
  );
}

export default AdminConfig;
